import { LessonPassportBadge, LessonPassportInfoItem, Text, useIntl } from 'platform-components/common';
import React, { useMemo } from 'react';

import { SPEC_COURSE_LESSON_STATUS } from 'common.components/spec-course/typings';

interface Props {
    status: SPEC_COURSE_LESSON_STATUS;
}

export const SpecCourseLessonViewPassportStatus = React.memo(({ status }: Props) => {
    const intl = useIntl();

    const label = intl.formatMessage({ id: 'lessonPassport.status.label' });
    const formattedStatus = intl.formatMessage({ id: 'lessonPassport.status.value' }, { status });

    const badge = useMemo(() => {
        switch (status) {
            case SPEC_COURSE_LESSON_STATUS.IN_PROGRESS:
                return <LessonPassportBadge />;
            default:
                return null;
        }
    }, [status]);

    return (
        <LessonPassportInfoItem label={label}>
            {badge}
            <Text size={Text.SIZE.XL} weight={Text.WEIGHT.M}>
                {formattedStatus}
            </Text>
        </LessonPassportInfoItem>
    );
});
